import React from 'react';
import Modal from './Modal';
import { isCreditCardPayment } from '../../utils/paymentMethodUtils';

/**
 * 会員登録成功時に表示するモーダル
 */
const SuccessModal = ({ 
  isOpen, 
  onClose, 
  memberId,
  paymentMethod, 
  memberData = null,
  language = 'ja',
  backgroundLoginStatus = null
}) => {

  const texts = {
    ja: {
      title: '会員登録完了',
      message: '会員登録が正常に完了しました。',
      memberIdLabel: '会員ID',
      continueButton: '口座振替情報を確認',
      creditCardButton: 'クレジットカード情報を入力',
      paymentNextStep: {
        creditCard: '次のステップでクレジットカード情報を入力してください。',
        bankTransfer: 'お支払い・口座振替の手続きについてご確認ください。'
      }
    },
    en: {
      title: 'Registration Complete',
      message: 'Your membership registration has been completed successfully.',
      memberIdLabel: 'Member ID',
      continueButton: 'Check Bank Transfer Info',
      creditCardButton: 'Enter Credit Card Information',
      paymentNextStep: {
        creditCard: 'Please enter your credit card information in the next step.',
        bankTransfer: 'Please check the payment and bank transfer procedures.'
      }
    }
  };

  const t = texts[language] || texts.ja;
  const isCreditCard = isCreditCardPayment(paymentMethod);

  /**
   * 続行ボタンのクリックハンドラー（手動実行のみ）
   */
  const handleContinue = () => {

    // completeStepは呼ばず、onCloseにデータを渡す
    onClose({
      shouldCompleteFlow: true,
      isCreditCard,
      data: {
        memberInfo: memberData,
        paymentMethod: paymentMethod,
        memberId: memberId
      }
    });
  };

  const styles = {
    container: {
      textAlign: 'center',
      padding: '20px'
    },
    message: {
      fontSize: '18px',
      color: '#333',
      marginBottom: '24px',
      lineHeight: '1.6'
    },
    memberIdContainer: {
      backgroundColor: '#f8f9fa',
      border: '2px solid #28a745',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '24px',
      cursor: 'pointer',
      transition: 'all 0.2s ease'
    },
    memberIdLabel: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#6c757d',
      marginBottom: '8px'
    },
    memberId: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#28a745',
      fontFamily: 'monospace',
      letterSpacing: '1px',
      userSelect: 'all'
    },
    copyHint: {
      fontSize: '12px',
      color: '#6c757d',
      marginTop: '8px'
    },
    // 支払い方法に応じた次ステップメッセージ
    paymentStepMessage: {
      backgroundColor: isCreditCard ? '#e3f2fd' : '#fff3e0',
      border: `2px solid ${isCreditCard ? '#2196f3' : '#ff9800'}`,
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '24px',
      fontSize: '14px',
      color: isCreditCard ? '#1565c0' : '#e65100',
      fontWeight: 'bold'
    },
    authStatusMessage: {
      fontSize: '12px',
      color: '#666',
      marginBottom: '16px',
      fontStyle: 'italic'
    },
    continueButton: {
      backgroundColor: isCreditCard ? '#007bff' : '#ff9800',
      color: 'white',
      border: 'none',
      padding: '14px 32px',
      borderRadius: '6px',
      fontSize: '16px',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      minWidth: '250px'
    },
    continueButtonHover: {
      backgroundColor: isCreditCard ? '#0056b3' : '#f57c00',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
    },
    flowStatusNote: {
      fontSize: '11px',
      color: '#6c757d',
      marginTop: '16px',
      fontStyle: 'italic',
      padding: '8px',
      backgroundColor: '#f8f9fa',
      borderRadius: '4px',
      border: '1px solid #e9ecef'
    }
  };

  return (
    <Modal 
      isOpen={isOpen}
      onClose={onClose}
      title={t.title}
      size="large"
      closeOnBackdropClick={false}
      showCloseButton={false}
    >
      <div style={styles.container}>
        {/* 登録完了メッセージ */}
        <p style={styles.message}>{t.message}</p>

        {/* 会員ID表示 */}
        {memberId && (
          <div 
            id="member-id-container"
            style={styles.memberIdContainer} 
          >
            <div style={styles.memberIdLabel}>{t.memberIdLabel}</div>
            <div style={styles.memberId} translate="no">{memberId}</div>
          </div>
        )}

        {/* 支払い方法に応じた次ステップメッセージ */}
        <div style={styles.paymentStepMessage}>
          {isCreditCard ? t.paymentNextStep.creditCard : t.paymentNextStep.bankTransfer}
        </div>


        {/* 続行ボタン（手動クリックが必要） */}
        <button 
          onClick={handleContinue}
          style={styles.continueButton}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, styles.continueButtonHover);
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = isCreditCard ? '#007bff' : '#ff9800';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          {isCreditCard ? t.creditCardButton : t.continueButton}
        </button>
      </div>
    </Modal>
  );
};

export default SuccessModal;